import type { ShippingRequest } from '@/lib/apiClient';
import { Badge } from '@/components';
import { fmtDate } from '@/lib/dates';
import { KIND_LABELS, STATUS_TONE, jobLabel } from './shippingForm';

/**
 * Shipping requests as a list, shared by a job's Shipping tab and the Shipping page. The ORDER is not decided
 * here: the API returns open requests before closed ones, Expedited first, then by the date they are needed,
 * which is the order Logistics works in, so a client sort would only get in the way.
 */
export default function ShippingList({ requests, showJob, onOpen }: {
  requests: ShippingRequest[];
  /** The page lists every job, so each row names its own; a job's tab already says whose it is. */
  showJob: boolean;
  onOpen: (r: ShippingRequest) => void;
}) {
  return (
    <ul className="shp-list" aria-label="Shipping requests">
      {requests.map((r) => (
        <li key={r.id}>
          <button type="button" className={`shp-row${r.expedited ? ' expedited' : ''}`} onClick={() => onOpen(r)}>
            <span className="shp-main">
              <span className="shp-badges">
                <Badge label={KIND_LABELS[r.kind] ?? r.kind} tone="neutral" />
                {r.expedited && <Badge label="Expedited" tone="danger" />}
              </span>
              <span className="shp-items">{r.items}</span>
              {showJob && <span className="shp-muted shp-small">{jobLabel(r)}</span>}
            </span>
            <span className="shp-route">{r.fromLocation ?? '—'} → {r.toLocation ?? '—'}</span>
            <span>
              <span className="shp-muted shp-small">Needed by</span>
              <br />
              {fmtDate(r.neededByDate)}
            </span>
            <span>
              <Badge label={r.status?.label ?? 'Unknown'} tone={STATUS_TONE[r.status?.code ?? ''] ?? 'neutral'} />
            </span>
            <span className="shp-muted">{r.requestorName ?? '—'}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
